import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles.scss'

  export const Maintenance = () => {
    return (
      <main style={{ textAlign: 'center', padding: '2rem' }}>
        <h1>Fixing stuff 🙄</h1>
        <p>Brb.</p> 
      </main>
    );
  };

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Maintenance />
  </React.StrictMode>,
)
